import { Component, HostListener, Input, OnInit, ViewChild, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { MatTableDataSource } from '@angular/material/table';

import { MatSort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';

import { ContainerAnimations } from 'src/app/shared/animations/container-animation';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/shared/services/user.service';
import { SupplierService } from 'src/app/services/supplier.services';
import { MatPaginator } from '@angular/material/paginator';
import { SharedServices } from 'src/app/shared/services/shared.service';
import { SupplierVehicleModel } from 'src/app/models/supplier-vehicle.model';
import { FileServerService } from 'src/app/services/file-server.service';
import { FileServerModel } from 'src/app/models/file-server.model';
import { UploaderSettingModel } from 'src/app/models/uploaderSetting.model';
import { SupplierModel } from 'src/app/models/supplier.model';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { NgClass } from '@angular/common';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import { MatInput, MatError } from '@angular/material/input';
import { FileUploaderComponent } from '../../../shared/components/file-uploader/file-uploader.component';
import { escapeBelongsToOverlay } from '../escape-key';

@Component({
    selector: 'app-supplier-profile-vehicle',
    templateUrl: './supplier-vehicle.component.html',
    styleUrls: ['./supplier-vehicle.component.scss'],
    animations: [ContainerAnimations.height],
    imports: [IconMenuButtonComponent, MatMenu, MatMenuItem, NgClass, FormsModule, ReactiveFormsModule, MatInput, MatError, FileUploaderComponent]
})
export class SupplierVehicleComponent implements OnInit {
  private readonly _liveAnnouncer = inject(LiveAnnouncer);
  private readonly supplierService = inject(SupplierService);
  usrSvc = inject(UserService);
  private readonly router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  toastr = inject(ToastService);
  sharedService = inject(SharedServices);
  fileServerSrv = inject(FileServerService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);

  supplierVehicleForm = new UntypedFormGroup({});

  suppName: any;
  showform: string = 'info';
  showInfoContent: boolean = true;
  supplierName: string = '';
  @Input() supplier!: SupplierModel;

  dataSource = new MatTableDataSource<SupplierVehicleModel>();

  supplierVehicleToEdit: SupplierVehicleModel | null = null;
  supplierId: string = '';
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  supplierVehicleList: SupplierVehicleModel[] = [];
  /** True once GET vehicles answered: the empty message is not shown while loading. */
  vehiclesLoaded = false;
  showVehicleForm: boolean = false;

  uploadersetting!: UploaderSettingModel;

  ngOnInit() {
    this.supplierVehicleForm = this.getForm();
    this.uploadersetting = {
      accept: ['image/png', 'image/jpg', 'image/jpeg'],
      imgMaxHeight: '250px',
      controller: 'fileServerSrv.Vehicles',
      formGroup: this.supplierVehicleForm,
    };
    this.loadSupplierVehicles();
  }

  // Loaded in ngOnInit (the supplier input is already set) so a cached answer renders in the first check.
  private loadSupplierVehicles(): void {
    let id = this.supplier.id.toString();

    if (id) {
      this.supplierService.get(id).subscribe((model) => {
        this.supplierName = model.fullName;
      });
      this.supplierId = id;
      this.getVehicles(this.supplierId);
    }
  }

  getForm() {
    return new UntypedFormGroup({
      id: new UntypedFormControl(Guid.EMPTY),
      brand: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('[A-Za-z0-9 ]+'),
      ]),
      plateNumber: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('[A-Za-z0-9 ]+'),
      ]),
      color: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z ]+$'),
      ]),
      trailer: new UntypedFormControl('', Validators.pattern('[A-Za-z0-9 ]+')),
      insurance: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('[A-Za-z0-9 ]+'),
      ]),
      trailerPlateNumber: new UntypedFormControl(
        '',
        Validators.pattern('[A-Za-z0-9 ]+')
      ),
      model: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('[A-Za-z0-9 ]+'),
      ]),
      trailerInsurance: new UntypedFormControl(
        '',
        Validators.pattern('[A-Za-z0-9 ]+')
      ),
      patentImg: new UntypedFormControl(null),
      frontPhotoImg: new UntypedFormControl(null),
      sidePhotoImg: new UntypedFormControl(null),
      trailerPhotoImg: new UntypedFormControl(null),
      trailerPatentImg: new UntypedFormControl(null),
    });
  }

  getVehicles(id: string) {
    this.supplierService
      .getAllVehicles(id)
      .subscribe((data: SupplierVehicleModel[]) => {
        this.supplierVehicleList = data;
        this.vehiclesLoaded = true;
        this.dataSource = new MatTableDataSource(this.supplierVehicleList);
      });
  }

  formInfoDocs(most: string): string {
    if (most == 'info') {
      this.showform = most;
      this.showInfoContent = true;
    } else {
      this.showform = 'documents';
      this.showInfoContent = false;
    }
    return this.showform;
  }

  onSubmit() {
    let model = this.supplierVehicleForm.value as SupplierVehicleModel;

    if (this.supplierVehicleForm.valid) {
      if (model.id != null && model.id.toString() != Guid.EMPTY) {
        this.supplierService.patchVehicle(model.id.toString(), model).subscribe(
          (data) => {
            this.saveImages(model.id.toString());
            this.getVehicles(this.supplierId);

            this.supplierVehicleForm.reset();
            this.formInfoDocs('info');

            this.toastr.success(
              'Actualización',
              'El vehículo se ha actualizado correctamente.'
            );
            this.closeVehiclesForm();
          },
          (err) => {
            this.toastr.error('Error', 'No se pudo registar el vehículo.');
          }
        );
      } else {
        this.supplierService.postVehicle(this.supplierId, model).subscribe(
          (data) => {
            this.getVehicles(this.supplierId);
            this.supplierVehicleForm.reset();
            this.formInfoDocs('info');
            this.closeVehiclesForm();
            this.toastr.success(
              'Registración',
              'El vehículo se registró correctamente.'
            );
          },
          (err) => {
            this.toastr.error('Error', 'No se pudo registar el vehículo.');
          }
        );
      }
    } else {
      this.supplierVehicleForm.markAllAsTouched();
      this.toastr.error(
        'Error',
        'Revise los campos obligatorios del formulario.'
      );
    }
  }

  saveImages(groupId: string) {
    if (
      this.supplierVehicleForm.controls.patentImg.value &&
      !this.supplierVehicleForm.controls.patentImg.value.id
    ) {
      let fileServerModel = this.supplierVehicleForm.controls.patentImg
        .value as FileServerModel;
      this.fileServerSrv
        .UploadTaskFile(
          groupId,
          fileServerModel,
          this.fileServerSrv.Vehicles,
          'patentImg'
        )
        .subscribe();
    }
    if (
      this.supplierVehicleForm.controls.frontPhotoImg.value &&
      !this.supplierVehicleForm.controls.frontPhotoImg.value.id
    ) {
      let fileServerModel = this.supplierVehicleForm.controls.frontPhotoImg
        .value as FileServerModel;
      this.fileServerSrv
        .UploadTaskFile(
          groupId,
          fileServerModel,
          this.fileServerSrv.Vehicles,
          'frontPhotoImg'
        )
        .subscribe();
    }
    if (
      this.supplierVehicleForm.controls.sidePhotoImg.value &&
      !this.supplierVehicleForm.controls.sidePhotoImg.value.id
    ) {
      let fileServerModel = this.supplierVehicleForm.controls.sidePhotoImg
        .value as FileServerModel;
      this.fileServerSrv
        .UploadTaskFile(
          groupId,
          fileServerModel,
          this.fileServerSrv.Vehicles,
          'sidePhotoImg'
        )
        .subscribe();
    }
    if (
      this.supplierVehicleForm.controls.trailerPhotoImg.value &&
      !this.supplierVehicleForm.controls.trailerPhotoImg.value.id
    ) {
      let fileServerModel = this.supplierVehicleForm.controls.trailerPhotoImg
        .value as FileServerModel;
      this.fileServerSrv
        .UploadTaskFile(
          groupId,
          fileServerModel,
          this.fileServerSrv.Vehicles,
          'trailerPhotoImg'
        )
        .subscribe();
    }
    if (
      this.supplierVehicleForm.controls.trailerPatentImg.value &&
      !this.supplierVehicleForm.controls.trailerPatentImg.value.id
    ) {
      let fileServerModel = this.supplierVehicleForm.controls.trailerPatentImg
        .value as FileServerModel;
      this.fileServerSrv
        .UploadTaskFile(
          groupId,
          fileServerModel,
          this.fileServerSrv.Vehicles,
          'trailerPatentImg'
        )
        .subscribe();
    }
  }

  editVehicle(model: SupplierVehicleModel) {
    this.openVehiclesForm();
    this.supplierService
      .getVehicle(model.id.toString())
      .subscribe((data: SupplierVehicleModel) => {
        this.supplierVehicleForm.reset();
        this.supplierVehicleToEdit = data;
        this.supplierVehicleForm.patchValue(data);
        this.fileServerSrv
          .GetTaskFiles(data.id.toString(), this.fileServerSrv.Vehicles)
          .subscribe((dataimg) => {
            dataimg.forEach((img) => {
              let model: FileServerModel = {
                id: img.id,
                groupId: data.id.toString(),
                name: img.name,
                imageSrc: img.publicUrl,
              };

              this.supplierVehicleForm.controls[img.group].patchValue(model);
            });
          });
      });
  }

  deleteVehicle(model: SupplierVehicleModel) {
    let vehicleId = model.id.toString();
    this.swalFire
      .SwalFireQuestion(
        'Eliminación',
        '¿Desea eliminar este vehículo?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.fileServerSrv
            .GetTaskFiles(vehicleId, this.fileServerSrv.Vehicles)
            .subscribe((dataimg) => {
              dataimg.forEach((img) => {
                this.fileServerSrv.delete(img.id).subscribe();
              });
            });

          this.supplierService.deleteVehicle(model.id.toString()).subscribe(
            (data) => {
              this.toastr.success(
                'Actualización',
                'El vehículo se eliminó correctamente.'
              );
              this.getVehicles(this.supplierId);
            },
            (err) => {
              this.toastr.error('Error', 'No se pudo eliminar el vehículo.');
            }
          );
        }
      });
  }

  disableDocuments() {
    return (
      this.supplierVehicleForm.controls.id.value == Guid.EMPTY ||
      this.supplierVehicleForm.controls.id.value == null ||
      this.supplierVehicleForm.controls.id.value == undefined
    );
  }

  openVehiclesForm() {
    this.disableDocuments();
    this.showVehicleForm = true;
  }

  @HostListener('window:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    // Escape on an open menu or file dialog overlay closes only that overlay.
    if (this.showVehicleForm && !escapeBelongsToOverlay(event)) {
      this.closeVehiclesForm();
    }
  }

  closeVehiclesForm() {
    this.supplierVehicleToEdit = null;
    this.formInfoDocs('info');
    this.supplierVehicleForm.reset();
    this.showVehicleForm = false;
  }
}
